import React, { useEffect, useState } from "react";
import SelectField from "../SelectField";
import { getCountriesWithNigeriaFirst } from "../../Utils/countries";

interface CountrySelectorProps {
  error?: string;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const CountrySelector = ({
  error,
  onChange,
  value,
  placeholder,
  className,
}: CountrySelectorProps) => {
  const [localValue, setLocalValue] = useState("");

  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  const handleChange = (nextValue: string) => {
    setLocalValue(nextValue);
    onChange(nextValue);
  };

  return (
    <SelectField
      className={className}
      showSearch
      label="Country"
      value={localValue}
      data={getCountriesWithNigeriaFirst()}
      placeholder={placeholder ?? "Choose"}
      onChange={handleChange}
      error={error}
    />
  );
};

export default CountrySelector;
